import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { NAV_ITEMS } from "@/components/feature/nav";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkBase =
    "flex items-center gap-1 whitespace-nowrap px-3 py-2 text-[15px] transition-colors";

  return (
    <header
      className={
        "sticky top-0 z-50 border-b border-background-200/80 bg-background-50/85 backdrop-blur-md transition-shadow " +
        (scrolled ? "shadow-[0_1px_0_0_oklch(var(--background-200))]" : "")
      }
    >
      <div className="container-x flex h-16 items-center justify-between gap-4 md:h-[72px]">
        {/* Brand */}
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 font-heading text-xl font-bold text-background-50 shadow-[inset_0_-3px_0_0_oklch(var(--primary-700))]">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-wide text-foreground-950 md:text-2xl">
              吃瓜日报
            </span>
            <span className="mt-1 text-[11px] text-foreground-500">
              实时吃瓜 · 大瓜盘点 · 蹲后续
            </span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                linkBase +
                (isActive
                  ? " font-bold text-primary-700"
                  : " text-foreground-700 hover:text-primary-600")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Right actions */}
        <div className="flex items-center gap-2 md:gap-3">
          <span className="hidden items-center gap-2 rounded-full border border-background-300 px-3 py-1.5 text-xs text-foreground-600 lg:flex">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600" />
            </span>
            实时更新中
          </span>
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            订阅吃瓜周报
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-xl text-foreground-800 md:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open ? (
        <nav className="border-t border-background-200 px-4 pb-4 pt-2 md:hidden" aria-label="移动导航">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                "flex items-center justify-between rounded-lg px-3 py-3 text-[15px] " +
                (isActive
                  ? "bg-primary-100 font-bold text-primary-700"
                  : " text-foreground-700")
              }
            >
              {item.label}
              <i className="ri-arrow-right-line text-foreground-400" />
            </NavLink>
          ))}
          <a
            href="#subscribe"
            className="mt-3 flex items-center justify-center rounded-md bg-primary-500 px-4 py-3 text-sm font-bold text-background-50"
          >
            订阅吃瓜周报
          </a>
        </nav>
      ) : null}
    </header>
  );
}